import * as locomotive from './locomotive';

export default (node) => {
	const accordions = node.querySelectorAll('.accordion');
	var active_el = false;

	accordions.forEach((accordion) => {
		var active = false;
		const expand = node.querySelector(`#${accordion.getAttribute('aria-controls')}`);
		const reverse = accordion.hasAttribute('data-reverse');
		const in_dialog = accordion.closest('.dialog') || false;
		const hash = accordion.id;

		if (!expand) return;

		if (window.location.hash.includes(hash) && hash.length > 1) {
			accordion.setAttribute('aria-expanded', "true");
			window.locomotive.update();
		}

		accordion.addEventListener('click', () => {

			// if (active_el && active_el !== accordion) {
			// 	active_el.setAttribute('aria-expanded', "false");
			// }

			active = (accordion.getAttribute('aria-expanded') == "false") ? true : false;
			accordion.setAttribute('aria-expanded', (active) ? "true" : "false");
			expand.classList[(active) ? "remove" : "add"]('hide');
			

			if (hash) {
				window.location.hash = hash;
			}
			window.locomotive.update();

			if (reverse) {
				var el = accordion;

				if (active) {
					el = expand;
				}

				if (!in_dialog) {
					window.locomotive.scrollTo(el, {
						duration: 500
					});
				}

			} else {
				if (active && !in_dialog) {
					window.locomotive.scrollTo(accordion, {
						duration: 500
					});
				}
			}

			if (active) {
				active_el = accordion;
			}
		})
	});
};